import React from "react";

export function StatBox({ icon: Icon, label, value, alert }) {
  return (
    <div className={`card-dark p-5 ${alert?"border-alert":""}`}>
      <Icon className={`w-5 h-5 mb-3 ${alert?"text-alert":"text-neon"}`}/>
      <div className="label-mono mb-1">{label}</div>
      <div className="font-display text-3xl">{value}</div>
    </div>
  );
}

// rows: [{ key, cells: [...] }]
export function DataTable({ headers, rows }) {
  return (
    <div className="card-dark overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-neutral-800">
            {headers.map(h=><th key={h} className="label-mono text-left p-4">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={headers.length} className="p-8 text-center text-neutral-500 font-mono">// NO_DATA</td></tr>}
          {rows.map(r=>(
            <tr key={r.key} className="border-b border-neutral-900 hover:bg-neutral-900/50">
              {r.cells.map((c,j)=><td key={headers[j]} className="p-4 font-mono text-xs text-neutral-300">{c}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const TABS = [
  ["overview","OVERVIEW"],["contents","CONTENUTI"],["events","EVENTI"],["lists","LISTE"],["folders","CARTELLE_FOTO"],["tables","TAVOLI"],
  ["payments","PAGAMENTI"],["users","UTENTI"],["scouting","SOCIAL_SCOUTING"],
];

export function AdminTabs({ tab, setTab }) {
  return (
    <div className="flex gap-2 overflow-x-auto mb-6 pb-2 font-mono text-xs tracking-widest">
      {TABS.map(([k,l])=>(
        <button key={k} onClick={()=>setTab(k)}
          className={`px-4 py-2 border whitespace-nowrap transition ${tab===k?"border-neon text-neon":"border-neutral-800 text-neutral-500 hover:text-white"}`}
          data-testid={`admin-tab-${k}`}>{l}</button>
      ))}
    </div>
  );
}

export const fmtDate = (iso) => new Date(iso).toLocaleDateString("it-IT");

export const affiliateLabel = (code, users, empty = "-") => {
  if (!code) return empty;
  const aff = users.find(u => u.referral_code === code);
  return `${aff ? aff.name : "?"} (${code})`;
};
